<template>
  <ModalDialog
    ref="dialog"
    :title="cancelTitle"
    :submitting="submitting"
    submitTitle="Cancel"
    icon="fa-times-circle"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="isTaskCancel">
        <NotificationBarTitle>This will cancel the task and all non-completed task items</NotificationBarTitle>
        <ul>
          <li>The task will be cancelled and cannot be completed</li>
          <li>Any items scanned in, but not processed, will be available for other tasks</li>
        </ul>
      </NotificationBar>

      <NotificationBar type="warning" v-if="isTaskItemCancel">
        <NotificationBarTitle>This will cancel the task item</NotificationBarTitle>
        <ul>
          <li>The task item will be cancelled and cannot be completed</li>
          <li>Any items scanned in will be available for other tasks</li>
        </ul>
        <strong>Note:</strong> If all items are cancelled, the task will be automatically cancelled
      </NotificationBar>
      
      <FormRow label="Cancel Reason">
        <FormInputTextArea ref="textEntryArea" v-model="cancelReason" placeholder="Enter reason and details for cancellation" field="reason" />
      </FormRow>
      <FormRow label="Cancel Labels" v-if="isTaskItemCancel">
        <FormLabelTag v-model="labelList" field="labelList" :labelType="LinkTypes.taskItemCancellation" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { LinkTypes } from '@/store/types'

export default {
  name: 'CancelTaskDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    taskId: Number,
    taskItemId: Number,
    isTaskCancel: Boolean,
    isTaskItemCancel: Boolean
  },
  data() {
    return {
      dialogForm: {},
      labelList: [],
      submitting: false,
      cancelReason: ''
    }
  },
  computed: {
    cancelTitle() {
      return this.isTaskCancel ? 'Cancel Task' : 'Cancel Task Item'
    }
  },
  created() {
    this.LinkTypes = LinkTypes
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.textEntryArea.focus()
    })
  },
  methods: {
    show() {
      // Reset form
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.dialogForm = { }

      if(this.isTaskItemCancel) {
        let labelIdList = this.labelList.map(label => label.id)

        this.submitting = true
        this.$apiService.tasksService.cancelTaskItem(this.taskId, this.taskItemId, { reason: this.cancelReason, labelList: labelIdList })
        .then(() => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
      }
      if(this.isTaskCancel) {
        this.submitting = true
        this.$apiService.tasksService.cancelTask(this.taskId, { reason: this.cancelReason })
        .then(() => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
      }      
    }
  }
}
</script>